import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { getClickAttrs } from '../Analytics/gtag';
import TrackedClick from '../Analytics/TrackedClick';

import styles from './menu.scss';

const MenuLink = (props) => {
    const { path, text, trackedContent, section, isLeagueLink = false, location, history, match, staticContext, ...rest } = props;
    const { pathname } = location;
    return (
        <TrackedClick
            eventName="Menu Cta Clicked"
            label={trackedContent || text}
            traits={
                {
                    sectionName: section || 'Menu',
                    content: trackedContent || text,
                }
}
        >
            {isLeagueLink ? (
                <a
                    href={path}
                    className={`${styles.menuItem} ${pathname === path ? styles.active : ''}`}
                    {...getClickAttrs({
                        category: 'Menu',
                        context: `Menu Item - ${text}`,
                        location: 'Menu',
                    })}
                    {...rest}
                >
                    {text}
                </a>
            ) : (
                <Link
                    className={`${styles.menuItem} ${pathname === path ? styles.active : ''}`}
                    to={path}
                    {...getClickAttrs({
                        category: 'Menu',
                        context: `Menu Item - ${text}`,
                        location: 'Menu',
                    })}
                    {...rest}
                >
                    {text}
                </Link>
            )}

        </TrackedClick>
    );
};

export default withRouter(MenuLink);
